import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isCompassEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('compass'),
)

export default isCompassEnabledSelector
